import React from "react";
import { PostContainer, Content, Picture } from "./Shared";
import PostFooter from "../PostFooter/PostFooter";

export default function ArticlePost(props) {
  if (props.image && !props.imageAlt) {
    console.warn("No image alt provided for Article", props.title);
  }
  const renderPostFooter = () =>
    props.activeAudience || props.showPostFooter ? (
      <PostFooter href={props.url} {...props} />
    ) : null;

  return (
    <PostContainer {...props}>
      {props.image ? (
        <Content noPadding>
          <Picture
            image={props.image || props.content}
            imageAlt={props.imageAlt}
            width={500}
          />
        </Content>
      ) : (
        <Content>{props.title}</Content>
      )}
      {renderPostFooter()}
    </PostContainer>
  );
}
